import { render } from "./MyProfileView.vue?vue&type=template&id=326b273c"
import script from "./MyProfileView.vue?vue&type=script&lang=js"
export * from "./MyProfileView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__